<template lang="pug">
div.modal-wrapper(:class="modalClassName")

    //- CONTENT
    main.modal-main

        //- HEADER
        header.modal-header(v-if="hasHeaderSlot")
            slot(name="header")
            
        //- BODY
        div.modal-body(v-if="hasContentSlot")
            slot(name="content")

        //- FOOTER
        footer.modal-footer(v-if="hasFooterSlot")
            slot(name="footer")
        //- footer(v-else)
            div.footer-content
                div.l-flex-row(v-for="button in buttons")
                    button.btn.btn--medium.btn--round(@click="button.action") {{ button.label }}
</template>

<script>
export default {
    name: 'ConfirmationModal',

    props: {
        modalClassName: { type: String, required: false, default: '' },
        buttons: { type: Array, required: false, default: () => [] }
    },

    computed: {
        hasHeaderSlot() {
            return !!this.$slots['header']
        },
        hasContentSlot() {
            return !!this.$slots['content']
        },
        hasFooterSlot() {
            return !!this.$slots['footer']
        }
    }
}
</script>
